import { render, staticRenderFns } from "./PromptEditor.vue?vue&type=template&id=6fbbe102&scoped=true&"
import script from "./PromptEditor.vue?vue&type=script&lang=js&"
export * from "./PromptEditor.vue?vue&type=script&lang=js&"
import style0 from "./PromptEditor.vue?vue&type=style&index=0&id=6fbbe102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbe102",
  null
  
)

export default component.exports